export default __webpack_public_path__ + "static/media/adele.ccb853cb.png";